import { z } from 'zod';

export const consumerGroupFormSchema = z.object({
  name: z
    .string()
    .min(1, '그룹명을 입력하세요')
    .max(128, '최대 128자'),
  description: z.string().max(500, '최대 500자').optional(),
  enabled: z.boolean().default(true),
});

export type ConsumerGroupFormValues = z.infer<typeof consumerGroupFormSchema>;
